/** @file Component that renders a date as time if it's today or shortened date if older. */
import moment from 'moment';
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as utils from '@/utils';
export default tsx.component({
    functional: true,
    props: {
        /** The date to display. */
        date: p(Object).validator(moment.isMoment).required,
        /** To wrap in a div or span. */
        tag: p.ofType().default('span'),
    },
    /** @returns The rendered time. */
    render(h, ctx) {
        const { date } = ctx.props;
        const now = ctx.parent.$getRootInstance().$getNow(date);
        const isToday = moment(date).local().isSame(now, 'day');
        const displayText = isToday
            ? utils.datetime.readableTimeOnly(date)
            : utils.datetime.readableShortDate(date);
        return h(ctx.props.tag, {
            attrs: {
                title: utils.datetime.readableFormatDate(date),
                ...ctx.data.attrs,
            },
            class: [ctx.data.class, ctx.data.staticClass],
        }, [displayText]);
    },
});
